import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // const apiBaseUrl = process.env.REACT_APP_REZA_BASE_local;
  const apiBaseUrl = "https://crm.ahangariholding.com";
  // const apiBaseUrl = "http://192.168.50.163:8000";

  // https://backtest.ahangariholding.com/
  // "https://crm.ahangariholding.com"

  useEffect(() => {
    const initAuth = async () => {
      setLoading(true);

      try {
        const token = localStorage.getItem("token");

        if (token) {
          const res = await axios.get(apiBaseUrl + "/api/auth/me", {
            headers: { Authorization: "Bearer " + token },
          });
          setUser(res.data.data.user);
        } else {
          setUser(null);
          localStorage.removeItem("token");
        }
      } catch (err) {
        console.error("General auth error:", err);
        localStorage.removeItem("token");
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const login = (userObject) => {
    setUser(userObject);
  };

  const logout = async () => {
    try {
      await axios.post(
        apiBaseUrl + "/api/auth/logout",
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
    } catch (error) {
    } finally {
      localStorage.removeItem("token");
      setUser(null);
      navigate("/login");
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        loading,
        apiBaseUrl,
        setUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
